import { Box, CircularProgress, Stack, Typography } from "@mui/material";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import { useTranslation } from "react-i18next";

export default function DownloadProgressCircle(props: { progress: number }) {
  const { t } = useTranslation();

  return (
    <Box display="flex" justifyContent="center" alignItems="center">
      {props.progress > 0 && props.progress < 100 && (
        <Stack alignItems="center" justifyContent="center">
          <CircularProgress value={props.progress} />
          <Typography textAlign="center" variant="body1">
            {Math.round(props.progress) + "%"}
          </Typography>
        </Stack>
      )}
      {props.progress === 100 && (
        <Stack direction="row" spacing={1}>
          <Typography textAlign="center" variant="h4">
            {t("Download completed!")}
          </Typography>
          <CheckCircleIcon color="success" />
        </Stack>
      )}
    </Box>
  );
}
